import { Component, Inject, Input } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ProductModel } from 'src/app/models/wardrobe.model';
import { ShippingService } from 'src/app/services/shipping.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BuyerShippingAddressPaymentComponent } from '../buyer-shipping-address-payment/buyer-shipping-address-payment.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delivery-pickup-modal',
  templateUrl: './delivery-pickup-modal.component.html',
  styleUrls: ['./delivery-pickup-modal.component.scss'],
  host: { class: 'delivery-pickup-modal-custom ship-modal' }
})
export class DeliveryPickupModalComponent {
  form: UntypedFormGroup;
  @Input() product: ProductModel;
  @Input() userId: number;      // Receive user ID
  @Input() chatId: string;      // Receive chat ID
  @Input() productId!: number; // Optional: receive product ID
  @Input() offered_product_id: number;
  @Input() userType: string; // Optional: receive product ID
  isModalOpen = false;
  selectedDeliveryType = ""; // Default to delivery
  showDeliveryFollowUpButton = false; // Flag to control visibility of the follow-up button
  isLoading: boolean;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private sendCloudService: ShippingService,
    protected translate: TranslateService
      // @Inject(ModalController) private navParams: any // or use NavParams in older Ionic

  ){
    this.userId = this.navParams.get('userId');
    console.log("🚀 ~ DeliveryPickupModalComponent ~ this.userId:", this.userId)
    this.product = this.navParams.get('product');
    this.productId = this.navParams.get('productId');
    this.chatId = this.navParams.get('chatId');
    console.log('Product:', this.product, 'User ID:', this.userId, 'Chat ID:', 'Product ID:', this.productId);
  }
  // selectOption(option: 'pickup' | 'shipping') {
    // Optionally send to backend here
    // this.modalCtrl.dismiss({ selectedOption: option }, option);
  // }



  ngOnInit() {
    // this.route.queryParams.subscribe(params => {
      // const offerStatus = params['offerStatus'];
      // const chatId = params['chatId'];
      // console.log("offerStatus", offerStatus, "chatId", chatId);
      // if (offerStatus === STATUS_ACCEPTED && chatId) {
      //   this.showPickupModal(chatId);
      // }
    // });
    // this.userId = this.navParams.userId;
    // this.productId = this.navParams.productId;
    console.log('User ID:', this.userId, 'Product ID:', this.productId);
    this.form = new UntypedFormGroup({
      offer_id: new UntypedFormControl(null),
      message: new UntypedFormControl(null),
      orderType: new UntypedFormControl(null), // add this line
    });
    // this.orderForm = new UntypedFormGroup({
    //   orderType: new UntypedFormControl(null)
    // });
  }


hideOrderOptions = false;
showPickupConfirmation = false;
showPickupFollowUpButton = true;
saveAddress = 0; // Default to not saving address
// pickupTimer: any;

// async chooseDeliveryOption(event: any) {
//   const selectedType = event.detail.value;

//   if (selectedType === 'delivery') {
//     this.hideOrderOptions = false;
//     this.showPickupConfirmation = false;
//     // clearTimeout(this.pickupTimer);
//     await this.openDeliveryModal();
//   } else if (selectedType === 'pickup') {
//     this.hideOrderOptions = true;
//     this.showPickupConfirmation = true;
//     this.modalCtrl.dismiss({ orderType: 'pickup' }, 'selected');

//     // Show confirm button after 5 minutes
//     // this.pickupTimer = setTimeout(() => {
//     //   this.showPickupConfirmation = true;
//     // }, ); // 5 minutes in ms
//     // }, 5 * 60 * 1000); // 5 minutes in ms
//   }
// }

// async openDeliveryModal() {
//   const modal = await this.modalCtrl.create({
//     component: DeliveryFormModalComponent,
//     componentProps: {
//       // Optional props
//       // chatId: this.chatId,
//       // senderId:this.user.id,
      
//       // productId: this.product?.id,
//       //  = this.route.snapshot.paramMap.get('id');
//     }
//   });
//   // console.log('Product ID:', sender.id);

//   await modal.present();

//   const { data, role } = await modal.onWillDismiss();
//   if (role === 'submit' && data) {
//       this.sendCloudService.sendOrderToCloud('delivery', data);
//     }
// }

// confirmPickup() {
//   this.sendCloudService.sendOrderToCloud('pickup');
//   this.showPickupConfirmation = false;
// }
  // dismiss() {
  //   this.modalCtrl.dismiss();
  // }


async chooseDeliveryOption(event: any) {
  const selectedType = event.detail.value;
  this.selectedDeliveryType = selectedType; // Store the selected type for later use
  const selectedOrderType = this.form.value.orderType || selectedType;

  if (selectedType === 'delivery') {
    this.showPickupConfirmation = false;
    // const selectedOrderType = this.form.value.orderType || null;
    // console.log('Selected Order Type:', selectedOrderType);
    await this.modalCtrl.dismiss({ success: true, selectedOrderType });
    // this.modalCtrl.dismiss({ success: true });
    // await this.openDeliveryModal();
  } 
  else if (selectedType === 'pickup') {
    // this.hideOrderOptions = true;
    this.selectedDeliveryType = selectedType;
    const selectedOrderType = this.form.value.orderType || null;
    console.log('Selected Order Type:', selectedOrderType);
    const payload = {
      // delivery_type: this.orderType,
      // name: formDetails.name,
      // address: formDetails.address,
      // house_number: formDetails.house_number,
      // street: formDetails.street,
      // city: formDetails.city,
      // country: formDetails.country,
      // postal_code: formDetails.postalCode,
      // shipping_status: formDetails.deliveryType === 'delivery' ? 'Delivery' : 'Pick Up',
      // phone_number: formDetails.phone,
      shipping_method_id: 0, // Assuming 0 for pickup
      chat_id: this.chatId,
      // userType: this.userType,
      
      order_Status: 0,
      // saveAddress: 0,
      // shippingType: selectedType,
    };
    try {
      await this.sendCloudService.sendOrderToCloud(
        this.userId,
        this.productId, 
        this.offered_product_id,
        this.userType,
        selectedType,
        this.saveAddress,
        payload
      ).toPromise();
      
      // Show success message or navigate
      // await this.modalCtrl.dismiss();
      this.showPickupConfirmation = true;
      this.showPickupFollowUpButton = false;
      await this.modalCtrl.dismiss({ success: true, selectedOrderType });
    } catch (error) {
      console.error('Error submitting shipping details:', error);
      // Show error to user
    } 
    finally {
      this.isLoading = false;
      // this.showPickupFollowUpButton = false
      // this.showPickupConfirmation = true;
    }
    // Do NOT dismiss modal here, wait for confirmPickup()
  }
}

// async openDeliveryModal() {
//   console.log('this.productId, this.userId, chatId', this.productId, this.userId, this.chatId);
//   const modal = await this.modalCtrl.create({
//     component: BuyerShippingAddressPaymentComponent,
//     componentProps: {
//       userId: this.userId,
//       chatId: this.chatId,
//       productId: this.productId,
//       orderType: this.selectedDeliveryType, // Pass the selected delivery type
//       userType: this.userType, // Pass the user type
//     },
//     canDismiss: true, // Prevent closing with swipe or ESC
//     backdropDismiss: true, // Prevent closing by clicking outside
  
//   });
//  modal.onDidDismiss().then((result) => {
//      if(data?.selectedOrderType !== 'delivery'){
//       debugger
      
//       this.isModalOpen = false; // Modal closed
//     }
//   });
//   await modal.present();
//   // const { data } = await modal.onDidDismiss();
//   const { data, role } = await modal.onWillDismiss();
// // if (role === 'cancel' || role === 'backdrop') { 
// // debugger
// //       this.isModalOpen = false;
// //     }



//   if (!data?.submitted) {
//       // Delivery modal was canceled or failed
//       this.form.get('orderType')?.setValue(null);
//       this.selectedDeliveryType = null;
//       this.showDeliveryFollowUpButton = true; // Optional follow-up button
//   }
//   // const { data, role } = await modal.onWillDismiss();
//   // if (role === 'submit' && data) {
//   //   // Instead of sending here, pass data back to parent
//   //   this.modalCtrl.dismiss({ orderType: this.selectedDeliveryType, deliveryData: data }, 'submit');
//   // }
// }

dismiss() {
    this.modalCtrl.dismiss({ isModalOpen: false });

  }
}
